import i18n from '@/plugins/vue-i18n'

export default [
  {
    path: '/challenges',
    name: 'challenges',
    component: () => import('./pages/Challenges.vue'),
    meta: {
      authenticatedOnly: true,
      breadcrumb: [
        {
          text: i18n.t('navigation.challenges'),
          to: {
            name: 'challenges'
          }
        }
      ]
    }
  }
]
